module.exports = __webpack_public_path__ + "img/illus-join-teleg.0b0e79f6.png";